var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0316 24.8703L24.8703 24.0316C25.0447 23.8572 25.0447 23.5752 24.8703 23.4008L20.3652 18.8956C20.2798 18.8103 20.1685 18.7658 20.0497 18.7658H19.5599C20.7289 17.4112 21.4377 15.6485 21.4377 13.7188C21.4377 9.4549 17.9828 6 13.7188 6C9.4549 6 6 9.4549 6 13.7188C6 17.9828 9.4549 21.4377 13.7188 21.4377C15.6485 21.4377 17.4112 20.7289 18.7658 19.5599V20.0497C18.7658 20.1685 18.814 20.2798 18.8956 20.3652L23.4008 24.8703C23.5752 25.0447 23.8572 25.0447 24.0316 24.8703ZM13.7188 19.6564C10.4383 19.6564 7.78127 16.9993 7.78127 13.7188C7.78127 10.4383 10.4383 7.78127 13.7188 7.78127C16.9993 7.78127 19.6564 10.4383 19.6564 13.7188C19.6564 16.9993 16.9993 19.6564 13.7188 19.6564Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.839427345a0eade0d1c2808dffbe594e.svg";
export { ForwardRef as ReactComponent };